<template>
  <NoAccessEmpty v-if="!getHasAccess" />
  <div v-else v-loading="isLoading" data-cy="attendees-table">
    <SSearchTable
      preset="attendee"
      :group-id="groupId"
      :selectable="false"
      :page-size="10"
      :page-size-options="[10, 25, 50, 100]"
      @loading-state:changed="onLoadingChanged"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { SSearchTable } from "@smeetz/ui-components";

import NoAccessEmpty from "@/components/common/NoAccessEmpty.vue";
import UserModule from "@/store/modules/user";

defineProps<{
  groupId: number;
}>();

const isLoading = ref(true);

// The ticket engine is granted to manager-level roles only. A seller gets a
// null token, which the table would render as an empty list.
const getHasAccess = computed(
  () => !!UserModule.getUser?.elasticSearchTokens?.ticket
);

/**
 * Mirror SSearchTable's loading state into the el-loading overlay.
 *
 * @param {boolean} loading - True when fetch is in-flight, false on settle.
 * @returns {boolean} Sentinel.
 */
function onLoadingChanged(loading: boolean): boolean {
  isLoading.value = loading;

  return true;
}
</script>
